<div class="container login">
  <div class="row">
    <div class="main-content col-12">

      <form name="loginForm" id="loginForm" class="loginForm col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4" (ngSubmit)="loginForm.valid && login(loginForm)" [formGroup]="loginForm" #f="ngForm" [class.ng-submitted-error]="f.submitted && f.form.invalid" novalidate>

        <div class="form-group required_section email">
          <div class="input-wrapper">
            <label for="email">
              {{ 'Login.Email' | translate }}
              <span class="required_asterisk">*</span>
            </label>
            <input type="email" placeholder="name@email.com" class="form-control" name="email" id="email" formControlName="email"/>
          </div>
          <div class="form-control-feedback"
               *ngIf="f.submitted && !!loginForm.controls.email.errors">
            <p *ngIf="!!loginForm.controls.email.errors.required">
              {{'Shared.Field_is_required' | translate}}
            </p>
            <p *ngIf="!!loginForm.controls.email.errors.pattern">
              {{'Shared.Email_isnt_valid' | translate}}
            </p>
            <p *ngIf="!!loginForm.controls.email.errors.maxlength">
              {{'Shared.Field_is_too_long' | translate}}
            </p>
          </div>
        </div>

        <div class="form-group required_section password">
          <div class="input-wrapper">
            <label for="password">
              {{ 'Login.Password' | translate }}
              <span class="required_asterisk">*</span>
            </label>
            <input type="password" class="form-control" name="password" id="password" formControlName="password"/>
          </div>
          <div class="form-control-feedback"
               *ngIf="f.submitted && loginForm.controls['password'].errors">
            <p *ngIf="!!loginForm.controls['password'].errors.required">
              {{'Shared.Field_is_required' | translate}}
            </p>
            <p *ngIf="!!loginForm.controls['password'].errors.minlength" translate [translateParams]="{ requiredLength: loginForm.controls['password'].errors.minlength.requiredLength, charactersLeft: loginForm.controls['password'].errors.minlength.requiredLength - loginForm.controls['password'].errors.minlength.actualLength }">
              Shared.Password_length_required
            </p>
          </div>
        </div>

        <div class="form-controls">
          <div class="controls-wrapper">
            <button class="main-action-btn form-submit-btn" type="submit">
              {{'Login.Login' | translate}}
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>
